import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_TRANSFER_RECIPIENT_METHODS_FAILURE,
    GET_TRANSFER_RECIPIENT_METHODS_SUCCESS,
} from '../actions/actionTypes';

export default function* getTransferRecipient(action) {
    const sapPartnerId = action.payload;
    const params = convertObjectToQueryParams(action.payload);
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/transferRecipient?orderType=ZLC&${params}`;
    try {
        if(sapPartnerId){
            const result = yield axios.get(url).then((response) => response.data);            
            yield put({
                type: GET_TRANSFER_RECIPIENT_METHODS_SUCCESS,
                payload: {
                    data: result.transferRecipientAddress || [],
                },
                statusCode: result.statusCode,
                statusMessage: result.statusMessage,
            });
        }
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_TRANSFER_RECIPIENT_METHODS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
